module.exports = __webpack_public_path__ + "components/incentive/static/nine-day-6c38a0ab9224965237e3897cd585c398.svg";